import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';
import { errorMessage } from './errorMessages';

export default config => {
    return async payload => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const wholeTokenFromCookie = JSON.parse(
            getCookieByName(sharedCookieKey)
        );

        let spatFromCookie = wholeTokenFromCookie.spat;

        let a = payload.ticket1_1_1 || '';
        let b = payload.ticket1_1_2 || '';
        let c = payload.ticket1_1_3 || '';
        let d = payload.ticket1_1_4 || '';
        let e = payload.ticket1_1_5 || '';

        payload.ticket_number = a + b + c + d + e;

        let checkResult = await apiClient(config).apiMethod({
            method: 'EnterTicket',
            headers: {
                Authorization: jwtFromCookie,
                'X-Auth-Spat': spatFromCookie,
            },
            args: {
                ...payload,
            },
        });

        // {"code":"_VALIDATION","message":"Input validation error.","data":{"ticket_number":["The ticket number field is required."]},"extended":""}
        if (checkResult.code) {
            return {
                success: false,
                message: errorMessage(checkResult.code),
            };
        } else if (checkResult) {
            return {
                entry: checkResult,
                success: true,
                message: 'success',
            };
        } else {
            return {
                success: false,
                message: errorMessage(),
            };
        }
    };
};
